export default "/_next/static/images/landingBg-4b075f0c895c67bf76f342294f992087.png";